import { useNavigate } from "react-router-dom";
import LazyImage from "../common/LazyImage/LazyImage";
import MotionReveal from "../common/MotionReveal/MotionReveal";
import { featuredProjectsContent } from "../../data/homeData";

function FeaturedProjects() {
  const navigate = useNavigate();
  const data = featuredProjectsContent;

  return (
    <section className="bg-[#071A2F] relative overflow-hidden py-16 lg:py-20">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-red-600/5 blur-[140px] rounded-full pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6">
        <MotionReveal variant="fadeUp" className="text-center">
          <span className="uppercase tracking-[0.3em] text-red-500 text-sm">
            {data.eyebrow}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-4">
            {data.title}
            <span className="block text-red-400 mt-1">{data.titleAccent}</span>
          </h2>
          <p className="mt-6 text-slate-400 max-w-3xl mx-auto text-justify text-sm sm:text-base">
            {data.intro}
          </p>
        </MotionReveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mt-12 sm:mt-16">
          {data.projects.map((project, index) => (
            <MotionReveal
              variant="fadeUp"
              delay={index * 100}
              as="button"
              className="group relative rounded-3xl overflow-hidden text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500"
              key={project.title}
              type="button"
              onClick={() => navigate(data.ctaLink)}
            >
              <LazyImage
                src={project.image}
                alt={project.title}
                className="h-64 sm:h-80 w-full object-cover transform-gpu will-change-transform transition-transform duration-700 ease-out group-hover:scale-105 backface-hidden"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-white text-lg sm:text-xl font-bold">{project.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-300 line-clamp-2">
                  {project.description}
                </p>
                <span className="inline-block mt-3 text-red-400 text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                  View Projects →
                </span>
              </div>
            </MotionReveal>
          ))}
        </div>

        <MotionReveal variant="fadeUp" className="text-center mt-10">
          <button
            type="button"
            onClick={() => navigate(data.ctaLink)}
            className="group relative inline-flex items-center overflow-hidden rounded-full border border-white/20 px-8 py-4 font-semibold text-white transition-all duration-300 hover:-translate-y-1 hover:scale-[1.03] hover:bg-white hover:text-slate-900 hover:shadow-xl"
          >
            <span className="relative z-10">{data.ctaLabel}</span>
            <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-all duration-700 group-hover:translate-x-full" />
          </button>
        </MotionReveal>
      </div>
    </section>
  );
}

export default FeaturedProjects;
